/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_LeadInputs */

const en_bot_lead = /** @type {(inputs: Bot_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot is Bystep's web reader. It only runs when a Bystep user asks for a public site to be dissected into a functional summary (features, flows, pricing, structure) as inspiration for their own product. Bystep does not copy your brand, text, images or look.`)
};

const id_bot_lead = /** @type {(inputs: Bot_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot adalah pembaca web milik Bystep. Ia hanya berjalan ketika seorang pengguna Bystep meminta situs publik dibedah menjadi ringkasan fungsional (fitur, alur, harga, struktur) sebagai inspirasi untuk produknya sendiri. Bystep tidak menyalin merek, teks, gambar, atau tampilan situs Anda.`)
};

/**
* | output |
* | --- |
* | "BystepBot is Bystep's web reader. It only runs when a Bystep user asks for a public site to be dissected into a functional summary (features, flows, pricing,..." |
*
* @param {Bot_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_lead = /** @type {((inputs?: Bot_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_lead(inputs)
	return en_bot_lead(inputs)
});